import React from "react";
import { useOutletContext, useSearchParams } from "react-router-dom";
import { FileSearch, PackageOpen } from "lucide-react";
import TraceabilitySearch from "../../components/TraceabilitySearch";
import MocaTraceSearch from "../../components/MocaTraceSearch";
import { Card } from "../../components/ui-kit";

export default function Tracciabilita() {
  const [params] = useSearchParams();
  const { isLocked } = useOutletContext();
  return (
    <div className="space-y-6" data-testid="tracciabilita-page">
      <div><p className="text-xs uppercase tracking-[0.18em] text-slate-400 font-body">Tracciabilità</p>
        <h1 className="font-heading text-3xl font-bold flex items-center gap-2"><FileSearch className="w-7 h-7 text-navy" /> Ricerca lotto e DDT</h1>
        <p className="text-sm text-slate-500 font-body mt-1">Dal lotto alla materia prima e al documento di acquisto ufficiale, in un clic. La stessa ricerca è anche in Ispezione ASL/NAS.</p></div>
      <TraceabilitySearch key={params.get("mancanti") || "tutti"} initialQuery={params.get("q") || ""} initialMissingOnly={params.get("mancanti") === "1"} />
      {!isLocked("moca") && <Card className="p-4 sm:p-6" data-testid="tracciabilita-moca">
        <h2 className="mb-1 flex items-center gap-2 font-heading text-xl font-semibold text-navy"><PackageOpen className="h-5 w-5" /> Imballaggi MOCA</h2>
        <p className="mb-4 text-sm text-slate-500">Dal lotto MOCA al DDT, alla certificazione del fornitore e alle produzioni in cui è stato usato.</p>
        <MocaTraceSearch />
      </Card>}
    </div>
  );
}
